import { render, staticRenderFns } from "./ResubmissionPage.vue?vue&type=template&id=f94666b6"
import script from "./ResubmissionPage.vue?vue&type=script&lang=js"
export * from "./ResubmissionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports